import { RouteConfig } from 'packages/route'
import { lazy } from 'react'

export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'task/quiz/:taskId',
    getTitle: () => '问卷',
    name: 'QuizTask',
    component: lazy(() =>
      import('./pages/Quiz').then((m) => ({
        default: m.Quiz,
      }))
    ),
  },
]
